import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
  inject,
  OnDestroy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { PersonimageService } from './service/personimage.service';
import { Personimage } from './model/personimage';
import { ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';
import {
  animate,
  style,
  transition,
  trigger
} from '@angular/animations';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { switchMap } from 'rxjs';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { TransPipe } from '@src/app/helpers/trans/trans.pipe';

@UntilDestroy()
@Component({
  selector: 'app-personimage',
  standalone: true,
  imports: [CommonModule, TransPipe, ImageCropperModule],
  templateUrl: './personimage.component.html',
  styleUrls: ['./personimage.component.css'],
  animations: [
    trigger('inbgOutAnimation', [
      transition(':enter', [
        style({ opacity: 0, position: 'absolute' }),
        animate('0.2s ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 0, position: 'absolute' }),
        animate('0.2s ease-in', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class PersonimageComponent implements OnInit, OnChanges {
  @Input() enableChange: boolean;
  @Input() bigimg: boolean;
  @Input() listtype = false;
  @Input() personimage: Personimage;
  @Input() personId: string;

  personimageurl: string = './assets/images/person_blank.webp';
  showSucces = false;
  logosize: string;
  selectedFiles: FileList;
  selectedFileName: string;
  showSpinner = false;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropperready = false;

  private personImageService = inject(PersonimageService);

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  ngOnInit() {
    const cachedUrl = sessionStorage.getItem('personimageurl' + this.personId);
    this.personimageurl = cachedUrl ?? this.personimageurl;

    if (!cachedUrl && this.personId) { 
      this.refreshUrl(this.personId);
    }

    this.logosize = this.bigimg || this.enableChange
      ? 'img-thumbnail-big'
      : 'img-chat-thumbnail-small';

  }

  toggleModal(){
    if ( SessionHelper.getPersonAuth().indexOf('et_admin') >= 0) {
      this.enableChange = !this.enableChange;
     } 
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.personId && changes.personId.currentValue) {
      const cachedUrl = sessionStorage.getItem('personimageurl' + this.personId);
      this.personimageurl = cachedUrl ?? './assets/images/person_blank.webp';

      if (!cachedUrl && this.personId) {
        this.refreshUrl(this.personId);
      }
    }
  }

  refreshUrl(personId: string) {
    this.showSpinner = true;
    this.personimage = {
      personId,
      date_added: new Date(),
      image: 'person_blank.webp',
      personimageurl: './assets/images/person_blank.webp'
    };

    this.personImageService.getPersonImageDB(personId)
      .pipe(untilDestroyed(this)).subscribe(pi => {
        if (pi && pi !== 'No image for this person.' && pi.personimageurl) {
          this.personimage = pi;
          this.personimageurl = pi.personimageurl;
          sessionStorage.setItem('personimageurl' + personId, pi.personimageurl);
        }
        this.showSpinner = false;
      });
  }

  onDocumentSubmit() {
    if (!this.selectedFileName || !this.croppedImage) return;

    this.showSpinner = true;
    this.showSucces = false;

    const filename = `${localStorage.getItem('user_sub')}_${this.selectedFileName}`;
    const file = this.base64ToFile(this.croppedImage, filename);

    this.personimage = {
      personId: this.personId,
      date_added: new Date(),
      image: 'person_blank.webp',
      personimageurl: './assets/images/person_blank.webp'
    };

    let objectUrl = '';
    let objectKey = '';

    this.personImageService.getSignedUploadUrl(filename)
      .pipe(
        untilDestroyed(this),
        switchMap(signedUrl => {
          objectUrl = signedUrl.objectUrl;
          objectKey = signedUrl.key;
          return this.personImageService.addPersonImageFile(file, signedUrl.url);
        }),
        switchMap(() => this.personImageService.addPersonImage({
          ...this.personimage,
          image: objectKey,
          personimageurl: objectUrl
        }))
      )
      .pipe(untilDestroyed(this)).subscribe(pi => {
        if (pi) {
          this.personimage = pi;
          this.personimage.personimageurl = objectUrl;
          this.personimageurl = objectUrl;
          sessionStorage.setItem('personimageurl' + this.personId, objectUrl);
        }
        this.showSpinner = false;
        this.showSucces = true;
      });
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.selectedFiles = event.target.files;
    this.selectedFileName = this.selectedFiles?.item(0)?.name ?? '';
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  cropperReady() {
    this.cropperready = true;
  }

  loadImageFailed() {
    // Optional: Add user feedback for image load failure
  }

  base64ToFile(data: string, filename: string): File {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    const u8arr = new Uint8Array(bstr.length);

    for (let i = 0; i < bstr.length; i++) {
      u8arr[i] = bstr.charCodeAt(i);
    }

    return new File([u8arr], filename, { type: mime });
  }

  selectFile(event: any) {
    this.selectedFiles = event.target.files;
    this.selectedFileName = this.selectedFiles?.item(0)?.name ?? '';
  }
}
